// What Quick view paints with (new scenes and new characters): GPT Image 2.5 Flare on low.
export const QUICK_PAINT = { model: "gpt", quality: "low" } as const;
